/* -- set app title -- */
const AppTitle = 'FRONTEND MODERN POKER CLUB';

/* -- set app mode -- */
const AppMode = ['production', 'development', 'testing', 'localhost']; 

/* -- set API URLs -- */
const testing = 'https://dserver.modernpokerclub.com';
const production = 'https://pserver.modernpokerclub.com';
const development = 'https://dserver.modernpokerclub.com';
const localhost = 'http://localhost:4000';

let SocketUrl, opensea;
let env = AppMode[1] ?? 'development', networkId = '', message = '', explorer = '', solanaExplorer = '', solanCluster = '', AlchemyUrl= '';

switch (env) {
  case 'development':
    networkId = 11155111;
    SocketUrl = development;
    explorer = 'https://sepolia.etherscan.io';
    message = 'Please switch your network to Sepolia testnet';
    opensea = 'https://testnets.opensea.io/';
    solanaExplorer = 'https://explorer.solana.com';
    solanCluster = 'devnet';
    AlchemyUrl = 'https://eth-sepolia.g.alchemy.com'
    break;
  case 'production':
    networkId = 1;
    SocketUrl = production;
    message = 'Please switch your network to Ethereum Mainnet';
    explorer = 'https://etherscan.io';
    opensea = 'https://opensea.io/';
    solanaExplorer = 'https://explorer.solana.com';
    solanCluster = 'mainnet-beta';
    AlchemyUrl = 'https://eth-mainnet.g.alchemy.com'
    break;
  case 'testing':
    networkId = 11155111;
    SocketUrl = testing;
    message = 'Please switch your network to Sepolia testnet';
    explorer = 'https://sepolia.etherscan.io';
    opensea = 'https://testnets.opensea.io/';
    solanaExplorer = 'https://explorer.solana.com';
    solanCluster = 'devnet';
    AlchemyUrl = 'https://eth-sepolia.g.alchemy.com'
    break;
  default:
    networkId = 11155111;
    SocketUrl = localhost;
    message = 'Please switch your network to Sepolia testnet';
    explorer = 'https://sepolia.etherscan.io';
    opensea = 'https://testnets.opensea.io/';
    solanaExplorer = 'https://explorer.solana.com';
    solanCluster = 'devnet';
    AlchemyUrl = 'https://eth-sepolia.g.alchemy.com'
}

let ApiUrl = `${SocketUrl}/api`;
export { AppTitle, ApiUrl, SocketUrl, opensea, networkId, message, explorer, env, solanaExplorer, solanCluster, AlchemyUrl };
